import { tokenStorage } from './storage-service';
import HttpEventPublisher from './http-event-publisher';

export default (config) => {
  HttpEventPublisher.publishRequest();

  const accessToken = tokenStorage.getAccessToken();
  // console.log('accessToken', accessToken);
  if (accessToken) {
    // eslint-disable-next-line no-param-reassign
    config.headers.common.Authorization = `Bearer ${accessToken}`;
  }

  return config;
};
